module.exports = __webpack_public_path__ + "static/media/marker-icon-2x-33dfff.9152373b.png";